var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sapling-list-preview"},[_c('ul',_vm._l((_vm.saplingList),function(sapling,index){return _c('li',{key:index},[_c('SaplingGeneRepresentation',{staticClass:"sapling-list-preview_sapling",attrs:{"sapling":sapling,"highlight-errors":_vm.highlightErrors}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }